<template>
  <v-dialog v-model="showDialog" width="800px">
    <v-overlay :value="isLoading">
      <v-progress-circular
        indeterminate
        color="primary"
        :size="70"
        :width="7"
      ></v-progress-circular>
    </v-overlay>
    <v-card class="search-modal">
      <h2 class="mb-3">Search & Add People</h2>
      <v-form @submit.prevent="search">
        <v-row>
          <v-col cols="3">
            <v-text-field
              outlined
              v-model="judgeId"
              label="Judge ID"
            />
          </v-col>
          <v-col cols="3">
            <v-text-field
              outlined
              v-model="membershipID"
              label="Member ID"
            />
          </v-col>
          <v-col cols="4">
            <v-text-field outlined v-model="nameSearchText" label="Name" />
          </v-col>
          <v-col cols="2">
            <v-btn v-on:click="search" color="primary">
              <v-icon> mdi-magnify </v-icon>
              Search
            </v-btn>
          </v-col>
        </v-row>
      </v-form>
      <p v-if="!!searchResults && !searchResults.length && hasSearched">
        No users found
      </p>
      <v-data-table
        v-if="!!searchResults && searchResults.length"
        :headers="headers"
        :items="searchResults"
        hide-default-header
      >
        <template v-slot:item="row">
          <v-tooltip dark right>
            <template v-slot:activator="{ on, attrs }">
              <tr v-bind="attrs" v-on="on">
                <td>
                  <a :href="`/admin/people/${row.item.personId}`" target="_blank">
                    {{ row.item.firstName }} {{ row.item.lastName }}
                  </a>
                </td>
                <td>{{ row.item.memberId }}</td>
                <td>
                  <font-awesome-icon
                    icon="id-card"
                    :color="row.item.isActiveMember == false ? 'red' : 'green'"
                  /><br/>
                  <span v-if="isActivemember(row.item)">Active for {{row.item.fullYearsOfActiveMembership}} years</span>
                </td>
                <td>
                  <a v-on:click="addLessee(row.item)">
                    <font-awesome-icon
                      icon="plus"
                      :color="isActivemember(row.item) ? 'blue' : 'gray'"
                    />
                  </a>
                </td>
              </tr>
            </template>
            <span v-if="isActivemember(row.item) == false"
              >This person is not an active member.</span
            >
            <span v-else>This person is an active member.</span>
          </v-tooltip>
        </template>
      </v-data-table>
      <p class="mb-6" v-if="selectedPeople.length">- or -</p>
      <v-btn
        color="primary"
        class="white--text"
        block
        :disabled="!selectedPeople.length"
        v-on:click="submit"
        >Continue</v-btn
      >
      <div v-if="selectedPeople.length">
        <h2 class="mt-8">Selected</h2>
        <v-data-table
          :headers="headers"
          :items="selectedPeople"
          hide-default-footer
          hide-default-header
        >
          <template v-slot:item="row">
            <tr v-bind="attrs" v-on="on">
              <td>
                  <a :href="`/admin/people/${row.item.personId}`" target="_blank">
                    {{ row.item.firstName }} {{ row.item.lastName }}
                  </a>
                </td>
                <td>{{ row.item.memberId }}</td>
                <td>
                  <font-awesome-icon
                    icon="id-card"
                    :color="row.item.isActiveMember == false ? 'red' : 'green'"
                  /><br/>
                  <span v-if="isActivemember(row.item)">Active for {{row.item.fullYearsOfActiveMembership}} years</span>
              </td>
              <td>
                <a v-on:click="removeLessee(row.item)">
                  <font-awesome-icon icon="minus" />
                </a>
              </td>
            </tr>
          </template>
        </v-data-table>
      </div>
    </v-card>
  </v-dialog>
</template>

<script lang="ts">
import Vue from "vue";
import adminService, {
  AdminSearchCoownersResult,
} from "@/services/adminService";
import { debounce } from "throttle-debounce";

export default Vue.extend({
  name: "AdminAddCoownerDialog",
  data: function () {
    return {
      showDialog: this.$props.peopleSearchDialog,
      hasSearched: false,
      searchResults: [] as any[],
      selectedPeople: this.$props.selectedPeopleList
        ? [...this.$props.selectedPeopleList]
        : [],
      membershipID: "",
      nameSearchText: "",
      judgeId: "",
      headers: [
        { text: "Name", align: "left", value: "name" },
        { text: "Member ID", align: "left", value: "memberId" },
      ],
      on: "",
      attrs: "",
      isLoading: false,
    };
  },
  watch: {
    peopleSearchDialog: function (newVal: boolean) {
      if (!newVal) {
        this.membershipID = "";
        this.hasSearched = false;
        this.searchResults = [] as AdminSearchCoownersResult[];
      }
      this.showDialog = newVal;
    },
    selectedPeopleList: function (newVal: any) {
      this.selectedPeople = newVal ? [...newVal] : [];
    },
  },
  methods: {
    search: function () {
      this.isLoading = true;
      this.hasSearched = false;
      adminService
        .adminSearchCoowners({
          memberId: this.$data.membershipID,
          nameSearchText: this.$data.nameSearchText, 
          judgeId: this.$data.judgeId
      })
        .then((response: any) => {
          this.isLoading = false;
          this.hasSearched = true;
          this.searchResults = response;
        });
    },
    isActivemember(coowner: AdminSearchCoownersResult) {
      return coowner.isActiveMember;
    },
    addLessee(row: any) {
      if (this.selectedPeople.length >= 6) return;
      if (this.selectedPeople.some((el) => el.personId === row.personId)) return;
      if (!this.isActivemember(row)) return;
      this.searchResults = [] as AdminSearchCoownersResult[];
      this.hasSearched = false;
      this.membershipID = "";      
      this.$emit("personAdded", { personId: row.personId });
      this.selectedPeople.push(row);
    },
    removeLessee(row: any) {
      this.selectedPeople.splice(this.selectedPeople.indexOf(row), 1);
      this.changeSelectedPeopleInfo(this.selectedPeople);
    },
    submit() {
      this.changeSelectedPeopleInfo(this.selectedPeople);
      this.showDialog = false;
    },
  },
  props: {
    changeSelectedPeopleInfo: Function,
    peopleSearchDialog: Boolean,
    toggleModal: Function,
    selectedPeopleList: Array,
  },
});
</script>